import { HashLink } from 'react-router-hash-link';
import PMID from './PMID';
import FirstRef from '../GeneDisease/FirstRef';
import LastRef from '../GeneDisease/LastRef';
import PValue from './PValue';

function AboutAttributesVariantDisease() {
  return (
    <div id="section46">
      <h3>Variant-Disease Associations</h3>
      <ul>
        <li className="bullet-item">
          The{' '}
          <HashLink to="#vdaScore" data-target="#metrics" data-toggle="tab">
            DISGENET score
          </HashLink>
        </li>
        <li className="bullet-item">
          The{' '}
          <HashLink to="#evindex" data-target="#metrics" data-toggle="tab">
            Evidence Index
          </HashLink>
        </li>
        <PMID />
        <FirstRef />
        <LastRef />
        <li className="bullet-item">
          A representative sentence from the publication describing the association between the variant and
          the disease (if a representative sentence is not found, we provide the title of the paper){' '}
        </li>
        <li className="bullet-item">The original source reporting the Variant-Disease Association.</li>
        <li className="bullet-item">
          Ancestry: ancestry information from the original GWAS study or identified from the publication by
          text-mining. Ancestry is standardized using the{' '}
          <a href="https://github.com/EBISPOT/hancestro" target="_blank" rel="noreferrer">
            Hancestro ontology
          </a>
          .
        </li>
        <li className="bullet-item">Gender: As reported in the original GWAS study</li>
        <li className="bullet-item">
          OR: Odds ratio associated with strongest SNP risk allele. Note that if an OR {'<'} 1 is reported
          this is inverted, along with the reported allele, so that all ORs are {'>'} 1
        </li>
        <li className="bullet-item">BETA: Beta-coefficient associated with strongest SNP risk allele.</li>
        <PValue />
        <li className="bullet-item">
          GOF/LOF: indicates that the variant is gain of function (GoF) or loss of function (LoF) mutation
          associated with the phenotype
        </li>
      </ul>
    </div>
  );
}

export default AboutAttributesVariantDisease;
